import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { ChecklistFieldShell } from '@/products/maintenance/features/protocol-renderer/checklist-field-shell';

type TextField = Extract<MaintenanceChecklistField, { type: 'short_text' } | { type: 'long_text' }>;

type Props = {
  field: TextField;
  readOnly?: boolean;
};

export function ChecklistTextField({ field, readOnly = true }: Props) {
  return (
    <ChecklistFieldShell field={field}>
      {field.type === 'long_text' ? (
        <Textarea disabled={readOnly} rows={3} />
      ) : (
        <Input disabled={readOnly} />
      )}
    </ChecklistFieldShell>
  );
}
